import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {ImageCarouselPaginationStyle} from '../../../types/galleryTypes';

/* istanbul ignore file */
export const carouselCustomCssVars = ({styleParams: styles}: CustomCssVarsFnParams) => {
  const arrowSize = styles.numbers.gallery_imageCarouselArrowSizeValue;
  const buttonSize = `${arrowSize}px`;
  const chevronSize = `${Math.round(arrowSize * 0.5)}px`;

  const paginationStyle = styles.strings.gallery_imageCarouselPaginationStyle?.value as ImageCarouselPaginationStyle;
  const paginationAlignment = styles.strings.gallery_imageCarouselPaginationAlignment?.value;
  const bottomPadding = styles.numbers.gallery_imageCarouselBottomPadding;

  return {
    imageCarouselButtonSize: buttonSize,
    imageCarouselChevronSize: chevronSize,
    imageCarouselPaginationStyle: paginationStyle,
    imageCarouselPaginationAlignment: paginationAlignment,
    gallery_imageCarouselBottomPadding: bottomPadding,
  };
};
